module.exports = __webpack_public_path__ + "static/assets/f30fbaf651a192c5c1c0cc6ab16bffe8.png";